// @ts-nocheck


import CommonApi from './../commonApi';

import { downloadRequestWithToken, fetchRequest } from './index';

import {
  convertFromKmToM,
  convertFromMToKm,
  convertFromSecondToHour,
  convertFromHourToSecond } from
'../pure/unitConversions';
import { convertDataFromServer as convertDataFromServerTrip } from './trip';

const convertDataFromServer = (wialonTrip) => ({
  ...wialonTrip,
  kilometrage: convertFromMToKm(wialonTrip.kilometrage),
  workHours: convertFromSecondToHour(wialonTrip.workHours),
  trip: wialonTrip.trip ? convertDataFromServerTrip(wialonTrip.trip) : null
});

const convertDataToServer = (wialonTrip) => ({
  ...wialonTrip,
  workHours: convertFromHourToSecond(wialonTrip.workHours),
  kilometrage: convertFromKmToM(wialonTrip.kilometrage)
});

const wialonTrip = new CommonApi(
  'wialonTrip',
  'Данные по пробегу wialon',
  convertDataToServer,
  convertDataFromServer
);

export const printTrip = async (id) => {
  const print = await downloadRequestWithToken(`/wialonTrip/${id}/print`);
  if (print) return print;
  throw new Error('Не удалось загрузить путевой лист');
};

export const print = async (params) => {
  const printed = await downloadRequestWithToken('/wialonTrip/print', {
    ...params
  });
  if (printed) return printed;
  throw new Error('Не удалось распечатать отчет');
};

export const getWialonData = async (params) => {
  const wialonData = await fetchRequest.post(
    '/wialonTrip/getWialonData',
    params
  );
  if (wialonData) return convertDataFromServer(wialonData);
  throw new Error('Не удалось запросить данные');
};

export const updateWialonData = async (wialonTripId) => {
  const wialonData = await fetchRequest.put(
    `/wialonTrip/updateWialonData/${wialonTripId}`,
    {}
  );
  if (wialonData) return convertDataFromServer(wialonData);
  throw new Error('Не удалось запросить данные');
};

export const printDeviationReport = async (
params) =>
{
  const printed = await downloadRequestWithToken(
    '/wialonTrip/deviationReport/print',
    {
      ...params
    }
  );
  if (printed) return printed;
  throw new Error('Не удалось распечатать отчет');
};

export default {
  ...wialonTrip,
  printTrip,
  print,
  printDeviationReport,
  getWialonData,
  updateWialonData
};